import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

export const isBackendConfigured = Boolean(url && key);
export const supabase = isBackendConfigured ? createClient(url!, key!) : null;

export async function invokeFunction<T>(name: string, body?: unknown): Promise<T> {
  if (!supabase) throw new Error("Backend is not configured.");
  const { data, error } = await supabase.functions.invoke(name, {
    body: body as Record<string, unknown> | undefined,
  });
  if (error) throw error;
  return data as T;
}
